import { HelpOutline } from '@mui/icons-material';
import { Box, Card, CardHeader, Tooltip, Typography } from '@mui/material';
import { t } from 'i18next';
import { ComponentLoader } from '../../../../common/components/ComponentLoader';
import { PriorityFix } from '../../models/PriorityFix';
import { PriorityFixes as PriorityFixesBlankState } from '../blankStates/PriorityFixes';
import { PriorityFixes as PriorityFixesSkeleton } from '../skeletons/PriorityFixes/PriorityFixes';
import { PriorityFixCard } from './PriorityFixCard';

type Props = {
  fixes: PriorityFix[] | null;
  loading: boolean;
  initialLoad: boolean;
};

const cardHeaderStyle = {
  borderBottom: 1,
  borderColor: 'divider',
  pt: 1.25,
  px: 2.5,
  pb: 0.625,
} as const;

export const PriorityFixes = ({ fixes, loading, initialLoad }: Props) => {
  if (initialLoad || fixes === null) {
    return <PriorityFixesSkeleton />;
  }
  return (
    <Card elevation={2}>
      <ComponentLoader loading={loading}>
        <CardHeader
          sx={cardHeaderStyle}
          title={
            <Typography variant="overline" sx={{ fontWeight: 500, color: 'text.secondary' }}>
              {t('priorityIssues')}
              <Tooltip title={t('helpTexts.priorityIssues')}>
                <HelpOutline fontSize={'inherit'} sx={{ verticalAlign: 'middle', ml: 1, mb: 0.375 }} />
              </Tooltip>
            </Typography>
          }
        />
        <Box sx={{ p: 0, pb: 1 }}>{fixes.length === 0 ? <PriorityFixesBlankState /> : fixes.map((fix, idx) => <PriorityFixCard key={idx} fix={fix} />)}</Box>
      </ComponentLoader>
    </Card>
  );
};
